import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, FormGroupDirective, Validators} from '@angular/forms';
import {HttpClient} from '@angular/common/http';
import {MatSnackBar} from '@angular/material/snack-bar';
import {environment} from '../environments/environment';
import {NgxSpinnerService} from 'ngx-spinner';
import {GoogleAnalyticsService} from './services/google-analytics.service';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';

interface ITechnologyWithDescription {
  order: number;
  iconName: string;
  imgAlt: string;
  title?: string;
  description?: string;
  link?: string;
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'IFenua';
  isProduction = environment.production;
  envName = environment.envName;

  @ViewChild('materialSnackBarSuccessTpl', {static: true}) materialSnackBarSuccessTpl: TemplateRef<any>;
  @ViewChild('materialSnackBarFailTpl', {static: true}) materialSnackBarFailTpl: TemplateRef<any>;

  @ViewChild('autosize') autosize: CdkTextareaAutosize;

  contactForm: FormGroup;

  isShowUserSpaceButton = false;
  isUseSimpleTemplate = true;

  listOfTechnologiesIconsToDisplay: Array<ITechnologyWithDescription> = [];


  constructor(
    private formBuilder: FormBuilder,
    private httpClient: HttpClient,
    private matSnackBar: MatSnackBar,
    private ngxSpinnerService: NgxSpinnerService,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) {}



  ngOnInit(): void {

    let order = 1;
    this.listOfTechnologiesIconsToDisplay.push(
      {
        order: order++,
        iconName: 'java-icon.svg',
        imgAlt: 'Java logo',
        title: 'Java',
        link: 'https://fr.wikipedia.org/wiki/Java_(langage)',
      },
      {
        order: order++,
        iconName: 'spring-3.svg',
        imgAlt: 'Spring framework logo',
        title: 'Spring',
        link: 'https://fr.wikipedia.org/wiki/Spring_(framework)',
      },
      {
        order: order++,
        iconName: 'flutter-with-name-logo.svg',
        imgAlt: 'Flutter logo',
        title: 'Flutter',
        link: 'https://fr.wikipedia.org/wiki/Flutter_(logiciel)',
      },
      {
        order: order++,
        iconName: 'angular-icon.svg',
        imgAlt: 'Angular logo',
        title: 'Angular',
        link: 'https://fr.wikipedia.org/wiki/Angular'
      },
      {
        order: order++,
        iconName: 'docker.svg',
        imgAlt: 'Docker logo',
        title: 'Docker',
        link: 'https://fr.wikipedia.org/wiki/Docker_(logiciel)',
      },
      {
        order: order++,
        iconName: 'centos-1.svg',
        imgAlt: 'CentOS logo',
        title: 'CentOS',
        link: 'https://fr.wikipedia.org/wiki/CentOS',
      },
      {
        order: order++,
        iconName: 'ovh-icon.svg',
        imgAlt: 'OVH logo',
        title: 'OVH',
        link: 'https://fr.wikipedia.org/wiki/OVHcloud',
      }
    );

    this.contactForm = this.formBuilder.group({
      name: [null, Validators.required],
      phone: [null],
      email: [null, [Validators.required, Validators.email]],
      subject: [null, Validators.required],
      message: [null, Validators.required]
    });

  }


  onClickMailto() {
    this.googleAnalyticsService.eventEmitter('click-mailto', 'link', 'click', 'Click on mailto contact@ifenua.pf');
  }

  sendFormContact(formDirective: FormGroupDirective) {

    this.googleAnalyticsService.eventEmitter('submit-contact-form', 'form', 'submit', 'Contact form');

    if (this.contactForm.valid) {

      const dataToSend = this.contactForm.value;

      this.contactForm.disable();
      this.ngxSpinnerService.show();

      this.httpClient.post(environment.coreApiUrl + '/contact-form', dataToSend)
        .subscribe(
          () => {

            this.matSnackBar.openFromTemplate(
              this.materialSnackBarSuccessTpl,
              {
                announcementMessage: 'Message envoyé !',
                duration: 10 * 1000, // 5 seconds
                verticalPosition: 'bottom',
                horizontalPosition: 'center',
                panelClass: 'bg-success',
              }
            );

            this.contactForm.enable();
            formDirective.resetForm();
            this.ngxSpinnerService.hide();

          },
          (err) => {

            console.log('Error when try to send email', err);

            this.contactForm.enable();
            this.ngxSpinnerService.hide();

            this.matSnackBar.openFromTemplate(
              this.materialSnackBarFailTpl,
              {
                announcementMessage: 'Erreur lors de l\'envoi du message !',
                duration: 10 * 1000, // 5 seconds
                verticalPosition: 'bottom',
                horizontalPosition: 'center',
                panelClass: 'bg-danger',
              }
            );

          },
        );

    }

  }

}
